var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.rangeBars = function (widget, chart, data, metadata) {   
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }

    setTimeout(function() {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);

        var container = $('<div class="range-bars">').css({ width: '90%', height: '90%', top: '5%', left: '5%' }); 

        var keys = MDB.Charts.getDataKeys(data[0]);
        var kendoConfig = {
            dataSource: {
                data: data
            },
            seriesDefaults: {
                type: 'rangeColumn',
                categoryField: keys[0],
                labels: {
                    visible: true,
                    from: {
                        template: '#=value.from#'
                    },
                    to: {
                        template: '#=value.to#'
                    }
                }
            },            
            chartArea: {
                height: MDB.Charts.calculateKendoChartMaxHeight(widget) 
            },
            series: [{
                fromField: keys[1],
                toField: keys[2]
            }],
            categoryAxis: {
                labels: {
                    //rotation: 'auto'
                }
            },
            tooltip: {
                visible: true,
                template: '#= value.from # - #= value.to #'
            }
        };
        $.extend(true, kendoConfig, metadata.KendoConfig);

        chart.append(container);
        container.kendoChart(kendoConfig);        
    }, 0);
};